import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CartSharedModule } from '@spartacus/cart/base/components';
import { CmsConfig, ConfigModule, FeaturesConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import {
  IconModule,
  ItemCounterModule,
  KeyboardFocusModule,
  PromotionsModule,
  SpinnerModule,
} from '@spartacus/storefront';
import { KnBrDirectiveModule } from 'src/shared/directive/kn-br-directive.module';
import { KnBrCustomPipesModule } from 'src/shared/pipe/kn-br-custom-pipes/kn-br-custom-pipes.module';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { AtgAddToCartComponent } from './atg-add-to-cart/atg-add-to-cart.component';



@NgModule({
  declarations: [AtgAddToCartComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    I18nModule,
    CartSharedModule,
    SpinnerModule,
    PromotionsModule,
    FeaturesConfigModule,
    UrlModule,
    IconModule,
    ItemCounterModule,
    KeyboardFocusModule,
    NgbModule,
    NgbDropdownModule,
    NgSelectModule,
    KnBrDirectiveModule,
    KnBrCustomPipesModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductAddToCartComponent: {
          component: () =>
            import('./atg-add-to-cart/atg-add-to-cart.component').then(
              (c) => c.AtgAddToCartComponent
            ),
        },
      },
    } as CmsConfig),
  ],
  exports: [AtgAddToCartComponent],
  providers: [],
})
export class AtgAddToCartModule {}
